// src/components/Navbar/Navbar.jsx

import React, { useState, useEffect } from 'react'; // <-- useEffect eklendi
import { Link } from 'react-router-dom'; 
import './Navbar.css'; 
import { FaBars, FaTimes } from 'react-icons/fa'; 
import sancakLogo from '../../assets/sancakLogo.png'; 

// --- YENİ: Firebase importları ---
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  // --- YENİ: Kategorileri tutacak state ---
  const [categories, setCategories] = useState([]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  }

  // --- YENİ: Kategorileri Firebase'den çek ---
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Kategorileri Firestore'dan çek (tıpkı ProductsPage'de yaptığımız gibi)
        const categoriesQuery = query(collection(db, "categories"), orderBy("name", "asc"));
        const categorySnapshot = await getDocs(categoriesQuery);
        const categoryList = categorySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCategories(categoryList); // State'i güncelle
      } catch (error) {
        console.error("Navbardaki kategorileri çekerken hata:", error);
      }
    };
    fetchCategories();
  }, []); // [] -> Sadece sayfa ilk yüklendiğinde bir kez çalışır

  return (
    <header className="navbar-container">
      <div className="navbar-content">
        <div className="navbar-logo">
          <Link to="/" onClick={closeMobileMenu}> 
            <img src={sancakLogo} alt="Sancak Hırdavat Logo" /> 
          </Link>
        </div>

        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      
        <nav className={isMobileMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <ul className="nav-menu-items"> 
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeMobileMenu}>Anasayfa</Link>
            </li>
            
            <li className="nav-item">
              <Link to="/#neden-sancak" className="nav-link" onClick={closeMobileMenu}>Hakkımızda</Link>
            </li>
            
            {/* Alt Menülü Ürünler Linki */}
            <li className="nav-item has-dropdown">
              <Link to="/urunler" className="nav-link" onClick={closeMobileMenu}>
                Ürünler 
                {/* <span className="dropdown-arrow">&#9660;</span> */}
              </Link>
              
              {/* --- GÜNCELLENDİ: Dinamik Dropdown Menü --- */}
              <ul className="dropdown-menu">
                {categories.length > 0 ? (
                  // Firebase'den gelen kategorileri map ile dön
                  categories.map(category => (
                    <li key={category.id}>
                      <Link 
                        // DİKKAT: category.name'i URL'ye uygun hale getiriyoruz
                        // Bu, "Ankastre Setler" -> "Ankastre%20Setler" yapar
                        to={`/urunler?kategori=${encodeURIComponent(category.name)}`} 
                        onClick={closeMobileMenu}
                      >
                        {category.name}
                      </Link>
                    </li>
                  ))
                ) : (
                  // Kategoriler yüklenirken veya yoksa
                  <li><span className="dropdown-loading">Yükleniyor...</span></li>
                )}
              </ul>
              {/* --- GÜNCELLEME BİTTİ --- */}

            </li>
            <li className="nav-item">
              <Link to="/iletisim" className="nav-link" onClick={closeMobileMenu}>İletişim</Link>
            </li>
          </ul>
        </nav>

      </div>
    </header>
  );
}

export default Navbar;